import { render, staticRenderFns } from "./selectElement.vue?vue&type=template&id=2e4accfb&scoped=true"
import script from "./selectElement.vue?vue&type=script&lang=js"
export * from "./selectElement.vue?vue&type=script&lang=js"
import style0 from "./selectElement.vue?vue&type=style&index=0&id=2e4accfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4accfb",
  null
  
)

export default component.exports